import { IList } from 'shared/entities/list';
import { LocalStorageKey } from 'shared/entities/localStorage';
import { IProject } from 'shared/entities/projects';
import { localStorageHandler } from 'stores/localStorageHandler';

const getLastProjectId = ({
  projects
}: {
  projects: IList<IProject, string>;
}): string | null => {
  const lastProjectId = localStorageHandler.getItem(
    LocalStorageKey.lastProjectId
  );

  // Если есть lastProjectId в localStorage и он есть в списке проектов данного кабинета
  if (lastProjectId && projects.getEntity(lastProjectId)) {
    return lastProjectId;
  }

  // Если есть проекты, то выбираем первый из списка
  if (projects.length) {
    return projects.items[0].id;
  }

  return null;
};

export default getLastProjectId;
